import * as React from 'react';
import * as _ from 'lodash';
import ListerField from './ListerField/ListerField';
import {FIELD_NAMES, VARIATION_PRODUCT_LISTING_DETAILS} from './consts';
import withStyles from '@material-ui/core/styles/withStyles';
import {createStyles} from '@material-ui/core/styles';
import {WithStyles} from '@material-ui/core/styles/withStyles';
import {
  getVariationsColumns,
  getVariationsTableRows,
  getVariationProductListingDetailsType,
  getItemId,
  isVariationsListing,
  getVariationAspectNames,
  isNonDraftItemId,
  getUpdatedEbayListingValues,
  getVariationsEnable,
  getCategorySpecifics,
  getAllEbayListingVariationsDeleted,
} from './ebayListingSelectors';
import update from 'immutability-helper';
import {Map} from 'immutable';
import connectWithRouter from '../../../shared/components/redux/connectWithRouter';
import {ColumnsType} from 'cl-table/redux/actions';
import {ACTION_DISPLAY_TYPES} from '../../../shared/ActionsManager/ActionsManagerConsts';
import EbayListingsActions from '../../../shared/ActionsManager/EbayListingsActions/EbayListingsActions';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../../../shared/ActionsManager/ActionsTypes';
import {Theme} from '@material-ui/core/styles/createMuiTheme';
import Switch from '@material-ui/core/Switch/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import {addDynamicDialog} from '../../../crazyEditor/redux/modules/panel/panel';
import Tooltip from '@material-ui/core/Tooltip';
import {updateFieldToRevise} from '../../ViewDesigns/redux/modules/ebayListing';
import {store} from '../../../App/store';
import ClearSelectionButton from 'cl-table/ClearSelectionButton';
import {sortColumnsWithChildren} from 'cl-table/VirtualizedHelpers';
import ListerVariationOptionsDialog from './ListerVariationOptionsDialog';
import BulkEditButton from 'cl-table/BulkEdit/BulkEditButton';
export const VARIATIONS_TABLE = 'variationsTable';
const SWITCH_TEXT = 'This listing has variations';
const SWITCH_LABEL = 'Add available product options like color or size.';

interface VariationsSectionProps extends WithStyles<typeof styles> {
  addDynamicDialog: typeof addDynamicDialog;
  deletedEbayListingVariations: object[];
  variationsListing: boolean;
  variationsData: Map<number, any>;
  variationProductListingDetailsType: string[];
  variationColumns: ColumnsType;
  itemId: string[];
  hasVariationColumns: boolean;
  disabledByEpid: boolean;
  disabledByCategory: boolean;
  disabledGeneral: boolean;
}

@connectWithRouter(
  state => ({
    deletedEbayListingVariations: getAllEbayListingVariationsDeleted(state),
    variationsListing: isVariationsListing(state),
    variationsData: getVariationsTableRows(state),
    variationProductListingDetailsType: getVariationProductListingDetailsType(state),
    variationColumns: getVariationsColumns(state),
    hasVariationColumns: !_.isEmpty(getVariationAspectNames(state)),
    itemId: getItemId(state),
    disabledByEpid: !_.isEmpty(_.get(getUpdatedEbayListingValues(state), FIELD_NAMES.EPID)),
    disabledByCategory: !getVariationsEnable(state),
    disabledGeneral: _.isUndefined(getCategorySpecifics(state)),
  }),
  {addDynamicDialog}
)
class VariationsSection extends React.PureComponent<VariationsSectionProps> {
  updateVariation = (columnName, variations, variationId, value) => {
    const {variationProductListingDetailsType} = this.props;
    let updatedVariation = _.includes(variationProductListingDetailsType, columnName)
      ? update(variations[variationId], {
          $merge: {
            [VARIATION_PRODUCT_LISTING_DETAILS]: {
              ...variations[variationId][VARIATION_PRODUCT_LISTING_DETAILS],
              [columnName]: value,
            },
          },
        })
      : update(variations[variationId], {
          [columnName]: {
            $set: value,
          },
        });
    return {[variationId]: updatedVariation};
  };

  handleSwitch = (event: object, checked: boolean) => {
    const {addDynamicDialog, deletedEbayListingVariations} = this.props;
    if (checked) {
      // checked is the new value
      addDynamicDialog(ListerVariationOptionsDialog);
    } else {
      store.dispatch(updateFieldToRevise(FIELD_NAMES.VARIATIONS, deletedEbayListingVariations));
    }
  };

  getDisabledTooltip = liveListing => {
    const {disabledByEpid, disabledByCategory, disabledGeneral, variationsListing} = this.props;
    const disabledByMultiLiveListing = liveListing && variationsListing;
    const disabledByNonMultiLiveListing = liveListing && !variationsListing;
    switch (true) {
      case disabledGeneral:
        return 'Select a category in order to add variations';
      case disabledByMultiLiveListing:
        return "You can't disable variations for a live listing";
      case disabledByNonMultiLiveListing:
        return 'A live listing cannot be changed to a multi-variant listing';
      case disabledByEpid:
        return "You can't add variations to a listing with an EPID";
      case disabledByCategory:
        return 'Variations are disabled for this eBay category';
      default:
        return 'Error';
    }
  };

  render() {
    const {
      variationsData,
      itemId,
      variationColumns,
      hasVariationColumns,
      disabledByEpid,
      disabledByCategory,
      disabledGeneral,
      classes: {switchContainer, switchLabel, switchText},
    } = this.props;
    const showVariations = hasVariationColumns && !variationsData.isEmpty() && !disabledGeneral;
    const liveListing = isNonDraftItemId(itemId);
    const switchDisabled = liveListing || disabledByEpid || disabledByCategory || disabledGeneral;
    const switchComponent = (
      <FormControlLabel
        control={
          <Switch
            id="cla-switch-variations"
            checked={!!showVariations}
            onChange={this.handleSwitch}
            disabled={switchDisabled}
            value="variations"
            color="primary"
          />
        }
        label={SWITCH_LABEL}
        classes={{label: switchLabel}}
      />
    );
    return (
      <div>
        <div className={switchContainer}>
          <div className={switchText}>{SWITCH_TEXT}</div>
          {switchDisabled ? (
            <Tooltip title={this.getDisabledTooltip(liveListing)}>{switchComponent}</Tooltip>
          ) : (
            switchComponent
          )}
        </div>
        {showVariations ? (
          <ListerField
            fieldName={FIELD_NAMES.VARIATIONS}
            name={VARIATIONS_TABLE}
            columns={variationColumns}
            data={variationsData}
            updateRow={this.updateVariation}
            config={{id: '_id', columnsSorter: sortColumnsWithChildren}}
            noWrap
            selectable
            actions={{
              left: (
                <EbayListingsActions
                  id="cla-btn"
                  types={[
                    EBAY_LISTINGS_ACTIONS_TYPES.OPEN_ADD_VARIATION_DIALOG,
                    EBAY_LISTINGS_ACTIONS_TYPES.OPEN_EDIT_VARIATION_OPTIONS_DIALOG,
                  ]}
                  displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
                  listingsIds={[itemId]}
                />
              ),
              selectedRight: (
                <React.Fragment>
                  <EbayListingsActions
                    id="cla-btn"
                    types={[EBAY_LISTINGS_ACTIONS_TYPES.DELETE_VARIATIONS]}
                    displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
                  />
                  <ClearSelectionButton />
                </React.Fragment>
              ),
              selectedLeft: <BulkEditButton />,
            }}
          />
        ) : (
          undefined
        )}
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    switchContainer: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    switchLabel: {
      color: theme.palette.grey[600],
    },
    switchText: {
      paddingRight: theme.spacing(2),
    },
  });

export default withStyles(styles)(VariationsSection);
